<template>
    <v-card
        width="800"        
        class="mx-auto pa-4"
        elevation="2"
        outlined
    >
       <StudentSubjectBatch
            v-bind:subjects="subjects"
            v-bind:teachers="teachers"
            v-bind:formClasses="formClasses"
            v-bind:formLevels="formLevels"
            v-bind:students="students"
        ></StudentSubjectBatch>  

        <v-overlay :value="overlay" absolute>
            <v-progress-circular 
                indeterminate 
                size="64"
            ></v-progress-circular>
        </v-overlay> 
    </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import StudentSubjectBatch from './StudentSubjectsBatch.vue';
export default {
    components: {
        StudentSubjectBatch,
    },

    created: function () {
        this.initialize();
    },
    data: () => ({
        students: [],
        subjects: [],
        teachers: [],
        formClasses: [],
        formLevels: [],
        overlay: false,
    }),

    methods: {
        ...mapActions({
            getStudents: 'subjectAssignments/getCurrentStudents',
            getFormClasses: 'timetable/getFormClasses',
            getSubjects: 'timetable/getSubjects',
            getEmployees: 'employees/getEmployees',
        }),

        async initialize(){
            this.overlay = true;
            try {
                const promiseGetStudents = this.getStudents();
                const promiseGetFormClasses = this.getFormClasses();
                const promiseGetSubjects = this.getSubjects();
                const promiseGetEmployees = this.getEmployees();

                const [
                    { data: dataStudents },
                    { data: dataFormClasses },
                    { data: dataSubjects },
                    { data: dataEmployees }
                ] = await Promise.all([
                    promiseGetStudents,
                    promiseGetFormClasses,
                    promiseGetSubjects,
                    promiseGetEmployees
                ])

                this.students = dataStudents;
                this.hasDuplicates(dataStudents)
                
                dataFormClasses.forEach(formClass => {
                    if(this.formLevels.indexOf(formClass.form_level) === -1){
                        this.formLevels.push(formClass.form_level)
                    }
                })
                this.formClasses = dataFormClasses
                this.subjects = dataSubjects;

                dataEmployees.forEach(employee => {
                    employee.name = employee.first_name + ', ' + employee.last_name;
                })

                this.teachers = dataEmployees;


            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);                
            }

            this.overlay = false;
        }, 
        
        hasDuplicates (data) {
            let students = [];
            let duplicates = [];
            data.forEach(value => {
                
                if(students.indexOf(value.student_id) === -1){
                    students.push(value.student_id);
                }
                else duplicates.push(value.student_id)
            })

            console.log(duplicates)
        },
        
    }
}
</script>